import { Tabs, TabsList, TabsTrigger } from "@/components/ui/tabs";

/** One tab per year, oldest first. */
export const VoltYearTabs = ({
  years,
  value,
  onChange,
  label = "Jahr",
  className,
}: {
  years: number[];
  value: number;
  onChange: (year: number) => void;
  label?: string;
  className?: string;
}) => (
  <Tabs
    value={String(value)}
    onValueChange={(v) => onChange(Number(v))}
    className={className}
  >
    <TabsList aria-label={label}>
      {[...years]
        .sort((a, b) => a - b)
        .map((y) => (
          <TabsTrigger key={y} value={String(y)}>
            {y}
          </TabsTrigger>
        ))}
    </TabsList>
  </Tabs>
);
